import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";


export const apiConfirmCME = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("programID", data.programID);
    form.append("appid", APPID);
    form.append("appversion", APPVERSION);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("detail", data.programID);
        form.append("detailvar", "programID")
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "confirmCME"
            },
            data: form
        });

        return response.data[0];
    } catch (error) {
        throw error;
    }
};

export const apiCompleteTest = async data => {
    let form = new FormData(); 
    form.append('mcid', data.mcid);
    form.append('key', data.key);
    form.append('qyear', data.qyear);
    form.append('gamemode', data.gamemode);
    
    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    if (typeof data.claimed !== 'undefined') {
        try {
            let response = await BASE_AXIOS().request({
                method: "POST",
                params: {
                    method: "claimSASPTest"
                },
                data: form
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    } else if (typeof data.processed !== 'undefined') {
        try {
            let response = await BASE_AXIOS().request({
                method: "POST",
                params: {
                    method: "processSASPTest"
                },
                data: form
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    } else {
        try {
            let response = await BASE_AXIOS().request({
                method: "POST",
                params: {
                    method: "completeSASPTest"
                },
                data: form
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
}